import mitt from "mitt";
import Util from "@/helper/Utility.js";
/**
 * setting
 * @method setTitle
 * @method setMsg
 * @method setBtnOk
 * @method clearModal
 * action
 * @method show
 * @method hide
 * set event callback
 * @method onClickOk
 * event
 * @event sendCallbackOk
 */
export function MarketingModalController () {
    this.title = '';
    this.msg = '';
    this.btnOk = '';
    this.busModal = mitt();

    this.callbackOk = null;

    //#region setter
    this.clearModal = function() {
        this.title = '';
        this.msg = '';
        this.btnOk = '';
        this.callbackOk = null;
        return this;
    };
    this.setTitle = function(title) {
        this.title = title;
        return this;
    };
    this.setMsg = function(msg) {
        this.msg = msg;
        return this;
    };
    this.setBtnOk = function(btnOk) {
        this.btnOk = btnOk;
        return this;
    };
    this.setLoadingModal = function(loadingModal) {
        this.loadingModal = loadingModal;
    };
    //#endregion setter

    //#region method
    this.show = function() {
        var config = {
            title: this.title,
            msg: this.msg,
            btnOk: this.btnOk,
        };
        this.busModal.emit('show', config);
    };
    this.hide = function() {
        this.busModal.emit('hide');
    };
    //#endregion method

    //#region event
    this.onClickOk = function(callback) {
        if (Util.isFunction(callback)) {
            this.callbackOk = callback;
        }
    },
    this.sendCallbackOk = function(data) {
        if (Util.isFunction(this.callbackOk)) {
            this.callbackOk(data);
        }
    };
    //#endregion event
}
